module.exports = __webpack_public_path__ + "media/images/products/retailers-customised-2-sample01-8c73109b1c5527a31890f931f00d5f18.jpg";